// extracted by mini-css-extract-plugin
export default {"thumbnail":"_3wSKL"};